import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle`
    @import url("https://fonts.googleapis.com/css?family=Roboto:400,500,600,700&display=swap");
    * {
        font-family: Roboto, Verdana, Geneva, Tahoma, sans-serif;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        color: ${props => props.theme.colors.primaryText};
        font-size: 14px;
    }

    body, html {
        background-color: ${props => props.theme.colors.background};
        overflow-x: hidden;
    }

    h1 {
        margin-bottom: 10px;
        margin-top: 30px;
        font-size: 40px;
        font-weight: 200;
        color: ${props => props.theme.colors.primary};
    }

    ::-webkit-scrollbar {
    width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: #555;
    } 
`;